import { Component, ViewEncapsulation, input } from '@angular/core';
import { ButtonComponent } from '../../atoms/button/button';

export type InsightsCtaPlacement = 'sidebar' | 'inline';

export interface InsightsCtaData {
  heading: string;
  body?: string;
  buttonLabel: string;
  buttonHref: string;
  placement?: InsightsCtaPlacement;
}

@Component({
  selector: 'ds-insights-cta-block',
  templateUrl: './insights-cta-block.html',
  styleUrl: './insights-cta-block.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [ButtonComponent],
})
export class InsightsCtaBlockComponent {
  readonly heading = input.required<string>();
  readonly body = input<string>();
  readonly buttonLabel = input.required<string>();
  readonly buttonHref = input.required<string>();
  readonly placement = input<InsightsCtaPlacement>('sidebar');
}
